import type {
  TaskAssignmentSearch,
  TaskRequestFilters,
} from '@/features/task-assignment/types/taskAssignment';

/** Convert URL-facing filter sentinels into the backend's optional query parameters. */
export function taskAssignmentSearchToFilters(search: TaskAssignmentSearch): TaskRequestFilters {
  return {
    projectId: search.projectId,
    status: search.status === 'all' ? undefined : search.status,
    workTypeId: search.workTypeId,
  };
}
